import { isArray } from 'lodash-es'

export const toSearchPageWhere = (formValue: any): Record<string, any> => {
  const where = {} as any

  for (const [key, value] of Object.entries(formValue)) {
    if (key !== 'archived' && !value) {
      continue
    }

    if (key === 'archived' && (value === 'all' || value === null)) {
      continue
    }

    if (key.endsWith('in') && ((isArray(value) && !value.length) || !value)) {
      continue
    }

    where[key] = value
  }

  return where
}
